import { useAppSelector } from "../../../../../redux/hooks"
import { KTIcon } from "../../../../../_metronic/helpers"
import { useEffect, useState } from 'react'
import { getCloudStatus, getCloudsStatus, getCloudStatusGlobal, getCloudsStatusG } from "../requests/request"
import { useAuth } from "../../../auth"

export default function StatusCtx(props: any) {
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)
  const { currentUser } = useAuth()

  const [statuCloud, setstatusCloud] = useState([{
    cloud: '',
    region: '',
    status: ''
  }])

  useEffect(() => {
    //if (FlagReg === true) {
      if (props.id === 1 && tenant === 0 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Home.Status')) {
        getCloudStatus(Id, Type, nameregion).then(response => {
          setstatusCloud(response.data)
        })
      } else if (tenant !== 0 && props.id === 1 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Home.Status')) {
        getCloudStatusGlobal(Id, Type, nameregion, tenant).then(response => {
          setstatusCloud(response.data)
        })
      } else if ( tenant === 0 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')) {
        getCloudStatus(Id, Type, nameregion).then(response => {
          setstatusCloud(response.data)
        })
      } else if (tenant !== 0 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')) {
        getCloudStatusGlobal(Id, Type, nameregion, tenant).then(response => {
          setstatusCloud(response.data)
        })
      }
   // }
  }, [props.id, nameregion, FlagReg])

  useEffect(() => {
    if (Id === -1 && props.id === 1 && tenant === 0 && currentUser?.ListPermiso?.includes('Home.Status')) {
      getCloudsStatus(-1).then(response => {
        setstatusCloud(response.data)
      })
    } else if (Id === -1 && props.id === 1 && tenant !== 0 && currentUser?.ListPermiso?.includes('Home.Status')) {
      getCloudsStatusG(-1, tenant).then(response => {
        setstatusCloud(response.data)
      })
    }
  }, [Type, Id])

  return (
    <>
      <div className="card card-custom border border-gray-300">
        <div>
          <br />
          <div className='text-marino f-titulo fs-md text-center'>CLOUD STATUS</div>
        </div>
        <div className="border shadow-sm rounded-lg menu-scroll">
          <div className="relative w-full overflow-auto">
            <div className="card-body card-scroll table-container h-250px">
              {statuCloud.length === 0 ? (
                <div className="no-data-message">No Data Available</div>
              ) : (
                <table className="w-full f-parrafo caption-bottom custom-table">
                  <thead className='table-header-light bg-marino table-header-fixed'>
                    <tr>
                      <th className="table-cell">Cloud</th>
                      <th className="table-cell">Region</th>
                      <th className="table-cell">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {statuCloud?.map((d, m) => (
                      <tr key={m} className="table-row">
                        {Id !== -1 && Type !== 'CloudGlobal' && <td className="table-cell">{d.cloud}</td>}
                        {Id !== -1 && Type !== 'CloudGlobal' && <td className="table-cell">{d.region}</td>}
                        {Type === 'AWS' && (
                          <td className="table-cell">
                            <span className='symbol-label'>
                              {d.status === "UP" && Id !== 0 && <KTIcon iconName='bi bi-check-circle' className='text-success fs-1' />}
                              {d.status === "Degradation" && Id !== 0 && <KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' />}
                              {d.status === "Informational" && Id !== 0 && <KTIcon iconName='bi bi-info-circle' className='text-primary fs-1' />}
                              {d.status === "Detected" && Id !== 0 && <KTIcon iconName='bi bi-info-circle' className='text-primary fs-1' />}
                            </span>
                          </td>
                        )}
                        {Type === 'OCI' && (
                          <td className="table-cell">
                            <span className='symbol-label'>
                              {d.status === "UP" && Id !== 0 && <KTIcon iconName='bi bi-check-circle' className='text-success fs-1' />}
                              {d.status === "Degradation" && Id !== 0 && <KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' />}
                              {d.status === "Informational" && Id !== 0 && <KTIcon iconName='bi bi-info-circle' className='text-primary fs-1' />}
                              {d.status === "Detected" && Id !== 0 && <KTIcon iconName='bi bi-info-circle' className='text-primary fs-1' />}
                            </span>
                          </td>
                        )}
                        {Type === 'AZR' && (
                          <td className="table-cell">
                            <span className='symbol-label'>
                              {d.status === "healthy" && Id !== 0 && <KTIcon iconName='bi bi-check-circle' className='text-success fs-1' />}
                              {d.status === "degraded" && Id !== 0 && <KTIcon iconName='bi bi-exclamation-circle' className='text-warning fs-1' />}
                              {d.status === "unhealthy" && Id !== 0 && <KTIcon iconName='bi bi-x-circle' className='text-danger fs-1' />}
                              {d.status === "advisory" && Id !== 0 && <KTIcon iconName='bi bi-info-circle' className='text-primary fs-1' />}
                              {d.status === "unknown" && Id !== 0 && <KTIcon iconName='bi bi-circle' className='text-gray-300 fs-1' />}
                            </span>
                          </td>
                        )}
                        {Type === 'CloudGlobal' && <td className="table-cell">{d.cloud}</td>}
                        {Type === 'CloudGlobal' && <td className="table-cell">{d.region}</td>}
                        {Type === 'CloudGlobal' && (
                          <td className="table-cell">
                            <span className='symbol-label'>
                              {d.status === "UP" && Type === 'CloudGlobal' && <KTIcon iconName='bi bi-check-circle' className='text-success fs-1' />}
                              {d.status === "Degradation" && Type === 'CloudGlobal' && <KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' />}
                              {d.status === "Informational" && Type === 'CloudGlobal' && <KTIcon iconName='bi bi-info-circle' className='text-primary fs-1' />}
                              {d.status === "Detected" && Type === 'CloudGlobal' && <KTIcon iconName='bi bi-info-circle' className='text-primary fs-1' />}
                              {d.status === "healthy" && Type === 'CloudGlobal' && <KTIcon iconName='bi bi-check-circle' className='text-success fs-1' />}
                              {d.status === "degraded" && Type === 'CloudGlobal' && <KTIcon iconName='bi bi-exclamation-circle' className='text-warning fs-1' />}
                              {d.status === "unhealthy" && Type === 'CloudGlobal' && <KTIcon iconName='bi bi-x-circle' className='text-danger fs-1' />}
                              {d.status === "advisory" && Type === 'CloudGlobal' && <KTIcon iconName='bi bi-info-circle' className='text-primary fs-1' />}
                              {d.status === "unknown" && Type === 'CloudGlobal' && <KTIcon iconName='bi bi-circle' className='text-gray-300 fs-1' />}
                            </span>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              {Id === 0 && Type !== 'Global' && (
                <table className="table table-striped gy-7 gs-7">
                  <tbody>
                    <tr>
                      <td className="text-center">Select a Cloud with available subscriptions</td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
            <div className="card-footer"></div>
          </div>
        </div>
      </div>
    </>
  )
}
